export default {
  en: {
    'BID_AMOUNT': 'Bid Amount',
    'DURATION': 'Duration',
    'NAME': 'Name',
    'REASON': 'Reason',
    'PRIORITY': 'Priority',
    'WEIGHT': 'Weight',
    
    'RPC_CALCULATION_DETAILS': 'Calculation Details',
    'RPC_DUPLICATE_DETAILS': 'Duplicate Details',
    'RPC_ERROR_DETAILS': 'Error Details',

    'RECORD': 'Record',
    'EVENTS': 'Events',
  }
};